import * as React from 'react';

import {Icon} from '.';
import {IconProps} from './type';
import {Path} from 'react-native-svg';

const DeleteTrashEmpty: React.FC<IconProps> = props => {
  return (
    <Icon {...props}>
      <Path
        fill={props?.fill ?? '#E54F37'}
        d="m13.58 5.94-.667 1.153-8.086-4.666.666-1.154L7.52 2.44l.907-.247 2.886 1.667.247.913 2.02 1.167ZM4 12.667v-8h3.38L12 7.333v5.334A1.334 1.334 0 0 1 10.667 14H5.333A1.334 1.334 0 0 1 4 12.667Zm1.333 0h5.334V8.133L6.973 6h-1.64v6.667Z"
      />
    </Icon>
  );
};

export default DeleteTrashEmpty;
